export const createMessageClientId = (serverId?: number) =>
  serverId === undefined
    ? `client-message-${crypto.randomUUID()}`
    : `server-message-${serverId}`;
